import React from 'react';
import { Box, Typography, Paper, Container } from '@mui/material';
import AppNav from '../../components/appNav';
import { ManagerContext } from '../../context/ManagerContext';

export default function SubscriptionPolicy() {
    const { manager } = React.useContext(ManagerContext);

    return (
        <Box sx={{ width: "100vw", minHeight: "100vh", bgcolor: 'background.default' }}>
            <AppNav />
            
            <Container maxWidth="lg" sx={{ py: 4 }}>
                <Paper elevation={3} sx={{ p: 4 }}>
                    <Typography 
                        variant="h4" 
                        gutterBottom 
                        sx={{ 
                            color: '#1D385E', 
                            fontWeight: 600, 
                            mb: 3,
                            textAlign: 'center'
                        }}
                    >
                        Política de Inscrições
                    </Typography>

                    <Box 
                        sx={{ 
                            mt: 3,
                            '& p': { mb: 2, textAlign: 'justify' },
                            '& h1, & h2, & h3, & h4, & h5, & h6': { 
                                color: '#1D385E', 
                                mt: 3, 
                                mb: 2 
                            },
                            '& ul, & ol': { 
                                pl: 3, 
                                mb: 2 
                            },
                            '& li': { 
                                mb: 1 
                            }
                        }}
                        dangerouslySetInnerHTML={{ 
                            __html: manager?.subscriberPolicy || '<p>Política de Inscrições não disponível no momento.</p>' 
                        }}
                    />
                </Paper>
            </Container>
        </Box>
    );
}
